import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'

import { IconName } from 'app/core/icons.const'
import { LoggerService } from 'app/core/logger/logger.service'

import { SvgBaseDirective } from './svg-base.directive'

@Component({
  selector: 'pai-icon',
  template: '',
  styles: `
    :host {
      display: flex;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent extends SvgBaseDirective {
  readonly icon = input.required<IconName>()
  protected readonly logger = inject(LoggerService).getInstance('IconComponent')
  protected readonly data = computed(() => ({ url: `/assets/icons/${this.icon()}.svg` }))
}
